import { CTAProps } from "./interface";
import classes from "./cta.module.scss";
import ImageWrapper from "../ImageWrapper";
import { ImageTypes } from "../ImageWrapper/interface";
import LinkWrap from "../../shared/LinkWrap/component";

const LinkCTA = ({
    text,
    description,
    linkUrl,
    linkText,
    imageUrl,
    imageAlt,
}: CTAProps) => {
    return (
        <div className={classes.ctaContainer}>
            <div className={classes.buttonCTA} data-testid="button-cta">
                <ImageWrapper
                    imageType={ImageTypes.Image}
                    url={imageUrl}
                    alt={imageAlt}
                    classNames={classes.image}
                />
                <div className={classes.buttonCTAContent}>
                    <div className={classes.descriptionContainer}>
                        <span className={classes.title}>{text}</span>
                        <span className={classes.descriptionText}>
                            {description}
                        </span>
                    </div>
                    <LinkWrap
                        url={linkUrl}
                        external={true}
                        className={classes.buttonLink}
                    >
                        {linkText}
                    </LinkWrap>
                </div>
            </div>
        </div>
    );
};

export default LinkCTA;
